import { render, staticRenderFns } from "./courier-editor.vue?vue&type=template&id=acab71ea&scoped=true&"
import script from "./courier-editor.vue?vue&type=script&lang=ts&"
export * from "./courier-editor.vue?vue&type=script&lang=ts&"
import style0 from "./courier-editor.vue?vue&type=style&index=0&id=acab71ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acab71ea",
  null
  
)

export default component.exports